import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/ui/popover.tsx
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var popoverContentVariants = cva(
  "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 origin-(--radix-popover-content-transform-origin) rounded-md border border-border shadow-md outline-hidden",
  {
    variants: {
      size: {
        sm: "w-56 p-3",
        md: "w-72 p-4",
        lg: "w-80 p-5",
        xl: "w-96 p-6"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
var Popover = ({
  ...props
}) => /* @__PURE__ */ jsx(PopoverPrimitive.Root, { "data-slot": "popover", ...props });
Popover.displayName = "Popover";
var PopoverTrigger = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Trigger, { "data-slot": "popover-trigger", ref, ...props }));
PopoverTrigger.displayName = "PopoverTrigger";
var PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, size, ...props }, ref) => {
  const contentSize = size || "md";
  return /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx(
    PopoverPrimitive.Content,
    {
      "data-slot": "popover-content",
      align,
      sideOffset,
      className: cn(popoverContentVariants({ size: contentSize }), className),
      ref,
      ...props
    }
  ) });
});
PopoverContent.displayName = "PopoverContent";
var PopoverAnchor = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Anchor, { "data-slot": "popover-anchor", ref, ...props }));
PopoverAnchor.displayName = "PopoverAnchor";

export {
  popoverContentVariants,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverAnchor
};
//# sourceMappingURL=chunk-CJ2S4EJP.js.map